import {customThemeConstants} from '@hconnect/uikit/src/lib2'
import DashboardIcon from '@mui/icons-material/Dashboard'
import {Button, Link} from '@mui/material'
import React from 'react'
import {generatePath} from 'react-router'

import {PLANT_DOWNTIME} from '../../consts'
import {hproduce} from '../../hproduce/config'
import {getButtonOutlineWhite} from '../../styles'
import {getHost} from '../../utils/route.utils'

export const generateDowntimeDashboardLink = (plantId: string) => {
  return getHost(hproduce.url) + generatePath(PLANT_DOWNTIME, {plantId})
}

type StyleVariant = 'onBlue' | 'onWhite'

type Props = {
  plantId: string
  title: string
  variant?: 'text' | 'outlined' | 'contained'
  styleVariant?: StyleVariant
  fullWidth?: boolean
  onClick?: () => void
}

export const DashboardLink: React.FC<Props> = ({
  plantId,
  title,
  variant,
  styleVariant = 'onWhite',
  fullWidth = false,
  onClick
}) => {
  const isOnBlue = styleVariant === 'onBlue'

  return (
    <Link
      sx={{textDecoration: 'none'}}
      href={generateDowntimeDashboardLink(plantId)}
      data-test-id="dashboard-link"
    >
      <Button
        variant={variant ?? 'text'}
        startIcon={<DashboardIcon />}
        sx={(theme) => ({
          width: fullWidth ? '100%' : '200px',
          height: '58px',
          ...(isOnBlue
            ? {
                color: 'white',
                borderColor: customThemeConstants().palette.mediumInputBorder
              }
            : getButtonOutlineWhite(theme))
        })}
        onClick={onClick}
      >
        {title}
      </Button>
    </Link>
  )
}
